import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Implements a paragraph component.
 *
 * **Base CSS Class:** `ph-paragraph`
 */

export default function CoreParagraph(props) {
	return (
		<p
			className={classnames('ph-paragraph', props.className)}
		>
			{props.children}
		</p>
	);
}

CoreParagraph.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string
};
